import {
  ApproveHoldsCommand,
  BulkApproveHoldsCommand,
  CreateHoldCommand,
  CreateHoldsCommand,
  HoldsApi,
  OverrideHoldsCommand,
} from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'

class HoldService {
  httpClient = createApiClient(HoldsApi)

  async fetchAll() {
    const { data } = await this.httpClient.getAll()
    return data
  }
  async fetchHoldsAuditTrail(journeyId: number) {
    const { data } = await this.httpClient.getAuditTrail(journeyId)
    return data
  }

  async getAuditTrailByHoldId(holdId: number) {
    const { data } = await this.httpClient.getAuditTrailByHoldId(holdId)
    return data
  }

  async create(cmd: CreateHoldCommand) {
    await this.httpClient.post(cmd)
  }

  async createBulk(cmd: CreateHoldsCommand) {
    await this.httpClient.postBulk(cmd)
  }

  async getByContainerJourneyId(containerJourneyId: number) {
    const { data } = await this.httpClient.getAll()
    return data.filter(h => h.containerJourneyId === containerJourneyId)
  }

  async approve(cmd: ApproveHoldsCommand) {
    await this.httpClient.approveHolds(cmd)
  }

  async bulkApprove(cmd: BulkApproveHoldsCommand) {
    await this.httpClient.bulkApproveHolds(cmd)
  }

  async override(cmd: OverrideHoldsCommand) {
    await this.httpClient.overrideHolds(cmd)
  }
}

const holdService = new HoldService()

export default holdService
